/**
 * Import Dependency
 */
import { dropdown } from '@/config/inkomensdecielen'

/**
 * Import API
 */
import { getChargingLocations, addChargingLocation, updateChargingLocation } from 'service/faunadb.js'

/**
 * Declare Variable
 */
const state = {
  layers: {},
  forecastStatus: {
    year: dropdown[0],
    access: 'public',
    forecast: 'determinative'
  },
  highlighted: 0,

  // Whether the map is done loading
  loaded: false,

  // Edit Mode
  editMode: false,

  // The first map layer, from the bottom, containing labels. 
  // All additional layers are to be placed below this layer.
  symbolLayerId: null,


  // Charging locations
  locations: []
}

const getters = {
  getForecastStatus: state => state.forecastStatus,
  getHighlighted: state => state.highlighted,
  getLoadedStatus: state => state.loaded,
  getEditMode: state => state.editMode,
  getLayers: state => state.layers,
  getSymbolLayerId: state => state.symbolLayerId,

  // 
  getLocations: state => state.locations
}
const actions = {
  async getChargingLocations({ commit }) {
    let response = await getChargingLocations()
    if (response && response.length !== 0) {
      commit('setChargingLocations', {
        locations: response
      })
    } else {
      commit('setChargingLocations', {
        locations: []
      })
    }
  },
  async addChargingLocation({ commit }, { label, id, userName, remark, coordinates, status } ) {
    let data = {
      coordinates,
      properties: {
        label, id, user_name: userName, remark: remark || '', status
      },
      created_at: Date.now(),
      updated_at: Date.now()
    }
    let response = await addChargingLocation({ data })
    commit('addChargingLocation', response)
    return response
  },
  async updateChargingLocation({ commit }, { ref, label, id, userName, coordinates, remark, status }) {
    let data = {
      coordinates,
      properties: {
        label, id, user_name: userName, remark: remark || '', status
      },
      updated_at: Date.now()
    }
    let response = await updateChargingLocation({ ref, data })
    commit('updateChargingLocation', response)
    return response
  },

  async deleteChargingLocation({ commit }, { ref }) {
    let data = {
      deleted_at: Date.now()
    }
    let response = await updateChargingLocation({ ref, data })
    commit('deleteChargingLocation', response)
    return response
  }
}
const mutations = {

  setChargingLocations(state, { locations }) {
    state.locations = locations
      .filter(location => 
        ( ! location.data.deleted_at || location.data.deleted_at === null)
      )
      .map(location => 
        Object.assign(location.data, { ref: location.ref })
      )
  },
  addChargingLocation(state, { data, ref }) {
    state.locations.push(Object.assign(data, { ref }))
  },
  updateChargingLocation(state, { data }) { 
    let index = state.locations.findIndex( 
      location =>  location.properties.id === data.properties.id
    )
    state.locations[index] = Object.assign(state.locations[index], data)
  },
  deleteChargingLocation(state, { data }) {
    let index = state.locations.findIndex( 
      location => location.properties.id === data.properties.id
    )
    if (index !== -1) {
      state.locations.splice(index, 1)
    }
  },

  // 
  updateForecastStatus(state, { year, access, forecast }) {
    if (year) {
      state.forecastStatus.year = year
    }
    if (access) {
      state.forecastStatus.access = access
    }
    if (forecast) {
      state.forecastStatus.forecast = forecast
    }
  },
  setHighlighted(state, { fid }) {
    state.highlighted = fid
  },
  setLoadedStatus(state, { status }) {
    state.loaded = status
  },
  setEditMode(state, { enabled }) {
    state.editMode = !! enabled
  },
  setLayerAvailability(state, { layer, status }) {
    state.layers[layer] = !!status
  },
  setSymbolLayerId(state, { id }) {
    state.symbolLayerId = id
  }
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
